import { Proyectos } from "./proyectos.view";
import "./style.scss";

export const SeguimientoProyectos = () => {
  return <Proyectos />;
};
